import React, { useEffect, useState } from 'react';
import styles from './pagination.module.scss';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

interface PaginationProps {
   items: number;
   itemsPerPage: number;
   setPageNumber: React.Dispatch<React.SetStateAction<number>>;
   pageNumber:number;
}

export default function Pagination(props: PaginationProps) {

   useEffect(() => {
      // Calculate the total number of pages based on the number of items
      const totalPagesCount = Math.ceil(props.items / props.itemsPerPage);
      // props.setPageNumber(1); // Reset current page when items or itemsPerPage change
      setTotalPages(totalPagesCount);
   }, [props.items, props.itemsPerPage]);

   const [totalPages, setTotalPages] = useState(1);

   const handlePageChange = (newPage: number) => {
      if (newPage >= 1 && newPage <= totalPages) {
         props.setPageNumber(newPage);
      }
   };

   const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      const inputPage = parseInt(event.target.value, 10);
      if (!isNaN(inputPage)) {
         handlePageChange(inputPage);
      }
   };

   const handlePrevPage = () => {
      handlePageChange(props.pageNumber - 1);
   };

   const handleNextPage = () => {
      handlePageChange(props.pageNumber + 1);
   };

   return (
      <div className={styles.paginationContainer}>
         <button
            className={props.pageNumber === 1 ? `${styles.navigates} ${styles.disabled}` : `${styles.navigates} ${styles.active}`}
            onClick={handlePrevPage}
            disabled={props.pageNumber === 1}
         >
            <NavigateBeforeIcon className={props.pageNumber === 1 ? `${styles.navigateIcon} ${styles.disabled}` : `${styles.navigateIcon} ${styles.active}`} />
         </button>
         <span>
            <input type="text" className={styles.inputField} value={props.pageNumber} onChange={handleInputChange} />
         </span>
         /{totalPages}
         <button
            className={props.pageNumber === totalPages ? `${styles.navigates} ${styles.disabled}` : `${styles.navigates} ${styles.active}`}
            onClick={handleNextPage}
            disabled={props.pageNumber === totalPages}
         >
            <NavigateNextIcon className={props.pageNumber === totalPages ? `${styles.navigateIcon} ${styles.disabled}` : `${styles.navigateIcon} ${styles.active}`} />
         </button>
      </div>
   );
}
